// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    absences: {
      label: 'Ausencias',
      help: 'Una fila por ausencia. No lleva ningún motivo ni dato médico',
    },
    dates: {
      from: 'Desde',
      to: 'Hasta',
    },
    metrics: {
      days: 'Días perdidos',
      absences: 'Ausencias',
      pending: 'Pendientes de respuesta',
      approved: 'Aprobadas',
      approvedDays: 'Días aprobados',
      charged: 'Días a cuenta del saldo',
      length: 'Duración media',
      approvalRate: 'Tasa de aprobación',
    },
    dimensions: {
      type: 'Tipo de ausencia',
      team: 'Equipo',
      worker: 'Persona',
      status: 'Estado',
      unit: 'Días, medio día u horas',
    },
    filters: {
      charged: 'Días a cuenta del saldo',
    },
  },
  ca: {
    absences: {
      label: 'Absències',
      help: 'Una fila per absència. No porta cap motiu ni dada mèdica',
    },
    dates: {
      from: 'Des de',
      to: 'Fins a',
    },
    metrics: {
      days: 'Dies perduts',
      absences: 'Absències',
      pending: 'Pendents de resposta',
      approved: 'Aprovades',
      approvedDays: 'Dies aprovats',
      charged: 'Dies a compte del saldo',
      length: 'Durada mitjana',
      approvalRate: 'Taxa d\'aprovació',
    },
    dimensions: {
      type: 'Tipus d\'absència',
      team: 'Equip',
      worker: 'Persona',
      status: 'Estat',
      unit: 'Dies, mig dia o hores',
    },
    filters: {
      charged: 'Dies a compte del saldo',
    },
  },
  en: {
    absences: {
      label: 'Absences',
      help: 'One row per absence. It carries no reason and no medical detail',
    },
    dates: {
      from: 'From',
      to: 'To',
    },
    metrics: {
      days: 'Days lost',
      absences: 'Absences',
      pending: 'Awaiting an answer',
      approved: 'Approved',
      approvedDays: 'Days approved',
      charged: 'Days charged',
      length: 'Average length',
      approvalRate: 'Approval rate',
    },
    dimensions: {
      type: 'Kind of absence',
      team: 'Crew',
      worker: 'Person',
      status: 'Status',
      unit: 'Days, half days or hours',
    },
    filters: {
      charged: 'Days charged',
    },
  },
  fr: {
    absences: {
      label: 'Absences',
      help: 'Une ligne par absence. Sans motif ni donnée médicale',
    },
    dates: {
      from: 'Du',
      to: 'Au',
    },
    metrics: {
      days: 'Jours perdus',
      absences: 'Absences',
      pending: 'En attente de réponse',
      approved: 'Approuvées',
      approvedDays: 'Jours approuvés',
      charged: 'Jours décomptés',
      length: 'Durée moyenne',
      approvalRate: 'Taux d\'approbation',
    },
    dimensions: {
      type: 'Type d\'absence',
      team: 'Équipe',
      worker: 'Personne',
      status: 'Statut',
      unit: 'Jours, demi-journées ou heures',
    },
    filters: {
      charged: 'Jours décomptés',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
